var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBarcodeH(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "29px",
    viewBox: "0 0 34 29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "action/24dp/scan") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.91111111,5.6 L8.63333333,5.6 L8.63333333,22.4 L5.91111111,22.4 L5.91111111,5.6 L5.91111111,5.6 Z M9.99444444,5.6 L11.3555556,5.6 L11.3555556,22.4 L9.99444444,22.4 L9.99444444,5.6 L9.99444444,5.6 Z M12.7166667,5.6 L16.8,5.6 L16.8,22.4 L12.7166667,22.4 L12.7166667,5.6 L12.7166667,5.6 Z M18.1611111,5.6 L19.5222222,5.6 L19.5222222,22.4 L18.1611111,22.4 L18.1611111,5.6 L18.1611111,5.6 Z M22.2444444,5.6 L24.9666667,5.6 L24.9666667,22.4 L22.2444444,22.4 L22.2444444,5.6 L22.2444444,5.6 Z M26.3277778,5.6 L27.6888889,5.6 L27.6888889,22.4 L26.3277778,22.4 L26.3277778,5.6 L26.3277778,5.6 Z M3.18888889,2.8 L3.18888889,8.4 L0.466666667,8.4 L0.466666667,2.8 C0.466666667,1.2536027 1.68544707,0 3.18888889,0 L8.63333333,0 L8.63333333,2.8 L3.18888889,2.8 L3.18888889,2.8 Z M30.4111111,0 C31.9145529,0 33.1333333,1.2536027 33.1333333,2.8 L33.1333333,8.4 L30.4111111,8.4 L30.4111111,2.8 L24.9666667,2.8 L24.9666667,0 L30.4111111,0 L30.4111111,0 Z M3.18888889,19.6 L3.18888889,25.2 L8.63333333,25.2 L8.63333333,28 L3.18888889,28 C1.68544707,28 0.466666667,26.7463973 0.466666667,25.2 L0.466666667,19.6 L3.18888889,19.6 L3.18888889,19.6 Z M30.4111111,25.2 L30.4111111,19.6 L33.1333333,19.6 L33.1333333,25.2 C33.1333333,26.7463973 31.9145529,28 30.4111111,28 L24.9666667,28 L24.9666667,25.2 L30.4111111,25.2 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "NextGen-POS",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Idle",
    transform: "translate(-148.000000, -105.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "action/24dp/scan",
    transform: "translate(148.250000, 105.250000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#54AF48",
    strokeWidth: 0.5,
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarcodeH);
export default __webpack_public_path__ + "static/media/barcode-h.6088c4c3.svg";
export { ForwardRef as ReactComponent };